import S from "./index.module.scss";
import { FC, ReactNode } from "react";
import Image from "next/image";
import clsx from "clsx";

interface IImageTextBlock {
  image: string;
  children: ReactNode;
  isLightPicture?: boolean;
}

const ImageTextBlock: FC<IImageTextBlock> = ({ children, image, isLightPicture }) => {
  return (
    <div className={S.blockWrapper}>
      <div className={S.childWrap}>{children}</div>
      <div className={clsx(S.imageWrap, { [S["imageWrap--light"]]: isLightPicture })}>
        <Image src={image} alt={image} width={800} height={900} className={S.image} />
      </div>
    </div>
  );
};

export default ImageTextBlock;
